module.exports = __webpack_public_path__ + "media/images/850/CBD_facts_woman_on_bed-17c581763cd373ac5d37e4fda1b95d17.webp";